import * as types from './types';

export const resetState = () => ({
  type: types.VACANCY_ACCESS_RESET_STATE
});

export const setFormLoading = (isFormLoading) => ({
  type: types.VACANCY_ACCESS_SET_FORM_LOADING,
  isFormLoading
});

export const setFormUpdating = (isFormUpdating) => ({
  type: types.VACANCY_ACCESS_SET_FORM_UPDATING,
  isFormUpdating
});

export const setVacancySchoolUsersSummaries = (vacancySchoolUsersSummaries) => ({
  type: types.VACANCY_ACCESS_SET_SCHOOL_USERS_SUMMARIES,
  vacancySchoolUsersSummaries
});

export const getVacancySchoolUsersSummaries = (schoolId, vacancyId) => ({
  type: types.VACANCY_ACCESS_GET_SCHOOL_USERS_SUMMARIES,
  schoolId,
  vacancyId,
});

export const setVacancySchoolUsersToDeny = (schoolId, vacancyId, putSchoolUsersToDenyAccessRequest) => ({
  type: types.VACANCY_ACCESS_SET_SCHOOL_USERS_TO_DENY,
  schoolId,
  vacancyId,
  putSchoolUsersToDenyAccessRequest
});



// WEBPACK FOOTER //
// ./src/actions/vacancies/vacancy-access/index.js